
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.0","viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.5 14c-1.5 0-2.7.4-3.6.9 1.4 1.2 2 2.6 2.1 2.7l.1.2V20h8v-2c-.1 0-1.7-4-6.6-4z"}}),_c('circle',{attrs:{"cx":"16.5","cy":"8.5","r":"3.5"}}),_c('g',[_c('path',{attrs:{"d":"M4 8.5C4 6.6 5.6 5 7.5 5S11 6.6 11 8.5 9.4 12 7.5 12 4 10.4 4 8.5zM7.5 14C2.6 14 1 18 1 18v2h13v-2s-1.6-4-6.5-4z"}})])])
          )
        }
      }
    